import React from "react";
import { ListFilters } from "../../common/DataList";

// Panneau de filtres de la liste des allocataires : rendu piloté par les
// définitions (recipientListConfig), groupées par thème. Les filtres
// principaux (orientation, compte) sont dans la barre de recherche.
const RecipientListFilters = (props) => <ListFilters {...props} />;

export default RecipientListFilters;
